module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 484
// module chunks = 85